import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const linkStyle = {
  color: '#666',
  textDecoration: 'none',
  margin: '0 10px',
};

export default function VersionFooter() {
  const { t } = useTranslation();

  return (
    <footer style={{
      textAlign: 'center',
      padding: '20px',
      marginTop: '40px',
      color: '#666',
      fontSize: '0.9rem',
      borderTop: '1px solid #e0e0e0'
    }}>
      <div style={{ marginBottom: '10px' }}>
        <Link to="/tokushoho" style={linkStyle}>{t('footer.tokushoho')}</Link>
        <Link to="/privacy" style={linkStyle}>{t('footer.privacy')}</Link>
        <Link to="/terms" style={linkStyle}>{t('footer.terms')}</Link>
        <a href={`mailto:${t('company.email')}`} style={linkStyle}>{t('footer.contact')}</a>
      </div>
      <div>
        © {new Date().getFullYear()} Quikbak. All rights reserved.
      </div>
    </footer>
  );
}
